module.exports = __webpack_public_path__ + "assets/d1aa7afb9e69704b9b5526312b175546.mp3";